<template>
  <div class="customerinfo main">
    <div class="scroller">
      <img class="ci-top-imgb" src="@static/images/customer_b.png" />
      <div class="ci-top">
        <div class="cti-info">
          <div class="cti-info-imgbox">
            <img
              class="cti-info-img"
              v-if="policyerSex == 0"
              src="@static/images/kehu.png"
            />
            <img
              class="cti-info-img"
              v-if="policyerSex == 1"
              src="@static/images/kehu1.png"
            />
            <img
              class="cti-info-img"
              v-if="policyerSex == 2"
              src="@static/images/kehu2.png"
            />
          </div>
          <span class="cti-name">{{ policyerName }}</span>
          <a :href="'tel:' + policyerMobile2">
            <div class="cti-phone-box">
              <span class="cti-phone">{{ policyerMobile2 }}</span>
            </div>
          </a>
        </div>
        <div class="cti-total">
          <div class="cti-bd">
            <span class="cti-bd-num">{{ totalPolicyNum }}</span>
            <span class="cti-bd-desc">累计保单</span>
          </div>
          <div class="cti-bd">
            <span class="cti-bd-num">{{ totalFee }}</span>
            <span class="cti-bd-desc">累计保费(元)</span>
          </div>
        </div>
      </div>
      <div class="cti-pro-content">
        <div
          class="cti-pro-citem"
          v-for="(item, index) in list"
          :key="index"
          @click="goPolicyDetail(item)"
        >
          <div class="order-name-zt">
            <span class="order-name">{{
              item.productName | subString(17)
            }}</span>
            <span
              :class="['order-zt', item.policyStatus == 1 ? 'order-liang' : '']"
              >{{ POLICY_STATUS[item.policyStatus] }}</span
            >
          </div>
          <div class="order-info">
            <div class="oi-left">
              <span class="oi-left-item">投保人:{{ item.policyerName }}</span>
              <span class="oi-left-item">保费:{{ item.fee }}元</span>
              <span class="oi-left-item"
                >投保时间:{{ item.createTime | timeSubstr(0, 16) }}</span
              >
            </div>
            <div class="oi-right">
              <div class="io-imgbox">
                <img class="io-img" :src="item.companyLogo" />
              </div>
            </div>
          </div>
          <div class="order-i-btns">
            <!-- <span
              class="o-btn o-payment-btn"
              @click.stop="seeYj(item)"
              v-if="
                item.policyStatus == 1 && item.commissonsNum != 0 && level != 3
              "
              >服务费</span
            >
            <span
              class="o-btn o-payment-btn"
              @click.stop="seeProduct(item)"
              v-if="item.policyStatus != 1 && item.isGift != 1"
              >重新分享</span
            > -->
            <span class="o-btn o-delete-btn">查看详情</span>
          </div>
        </div>
      </div>
      <div class="null" v-if="list.length <= 0 && nullshow">
        <img class="null-img" src="@static/images/null2.png" />
        <span class="null-text">暂无数据</span>
      </div>
    </div>
    <serviceBox :id="detailId" :show.sync="showModal"></serviceBox>
  </div>
</template>
<script>
import serviceBox from "@/components/serviceBox";
import { common } from "@/api/mixins";
export default {
  components: { serviceBox },
  mixins: [common],
  data() {
    return {
      POLICY_STATUS: {
        //保单状态 1已承保-1已退保0已终止
        1: "保障中",
        "-1": "已退保",
        0: "已过期",
      },
      showShare: false,
      shareData: {
        href: "", //分享的链接地址
        title: "凤栖云服", //分享的标题
        desc: "", //分享的描述
      },
      active: "",
      policyerMobile2: "",
      policyerMobile1: "",
      totalFee: "",
      totalPolicyNum: "",
      policyerName: "",
      policyerSex: "",
      detailId: "", //服务费弹窗ID
      showModal: false, //是否显示服务费弹窗
      nullshow: false,
      list: [],
    };
  },
  created() {
    const query = this.$route.query;
    this.$weixin.hideMenu();
    this.setAllData({ type: "POLICY_STATUS" });
    this.level = query.level;
    this.policyerMobile2 = query.policyerMobile2;
    this.policyerMobile1 = query.policyerMobile1;
    this.totalFee = query.totalFee;
    this.policyerName = query.policyerName;
    this.policyerSex = query.policyerSex;
    this.totalPolicyNum = query.totalPolicyNum;
    this.getMyPolicysHttp();
  },
  methods: {
    seeProduct: function (item) {
      const shareData = {
        title: item.productName,
        link: item.productUrl,
        content: item.profile,
        logo: item.shortImg,
      };
      this.openSharePanel(shareData, true);
    },
    getMyPolicysHttp: function () {
      this.$http({
        type: "PUT",
        url: "/app/policy/getMyPolicys",
        data: {
          pageNum: 1,
          pageSize: 9999,
          policyerMobile1: this.policyerMobile1,
          orderBy: "id",
        },
      }).then(
        (resData) => {
          this.nullshow = true;
          this.list = resData.data.data.page.records;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    goPolicyDetail(item) {
      this.$router.push({
        path: "/apps/order/detail",
        query: {
          policyNo: item.policyNo,
          orderNo: item.orderNo,
        },
      });
    },
    seeYj: function (item) {
      this.detailId = item.id;
      this.showModal = true;
    },
  },
};
</script>

<style lang='scss' scoped>
@import "~@/sass/native";
@import "./customerInfo";
</style>
